import { location } from '@townsquare/facade/window';

const SITE_IDENTIFIER_REGEX = new RegExp(`/s/(?<siteIdentifier>[a-zA-Z0-9%+-]+)*`);
const SITE_IDENTIFIER_QUERY_REGEX = new RegExp(`cloudId=(?<siteIdentifier>[a-zA-Z0-9%+-]+)`);

export function getSiteIdentifier(): string | undefined {
	const match = SITE_IDENTIFIER_REGEX.exec(location().pathname);
	const pathSiteId = match?.groups?.siteIdentifier;

	if (pathSiteId) {
		return pathSiteId;
	}

	const queryMatch = SITE_IDENTIFIER_QUERY_REGEX.exec(location().search);
	const querySiteId = queryMatch?.groups?.siteIdentifier;

	return querySiteId;
}
